import { Status } from "./AlertStatus.styles";

type AlertsCounterProps = React.ComponentProps<typeof Status> & {
  children: React.ReactNode;
};

export function AlertsStatus({ children, ...rest }: AlertsCounterProps) {
  return <Status {...rest}>{children}</Status>;
}
